export const resolveLocalPersonaSignInPassword = ({
  manualPassword,
  configuredPassword,
  devDefaultPassword,
  skipPassword,
}: {
  manualPassword: string;
  configuredPassword: string | null | undefined;
  devDefaultPassword: string;
  skipPassword: boolean;
}): {
  password: string;
  requiresManualPassword: boolean;
} => {
  const manual = manualPassword.trim();
  const configured =
    typeof configuredPassword === "string" ? configuredPassword.trim() : "";
  const devDefault = devDefaultPassword.trim();
  const password = skipPassword ? manual || configured || devDefault : manual;
  return {
    password,
    requiresManualPassword: !password,
  };
};
